import React from "react";

import VetExamFormField from "../../../VetExamFormField";
import EntryItem from "../../../EntryItem";
import {
  createEmptyExamDetailObservation,
  EVetExamFields,
  examDetailsObservationsFields,
  FormField,
  IExamDetail,
  IExamDetailObservation
} from "../../../options";
import { checkSelectingFieldsOneEntry } from "../../../helper";
import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import useParentsStyles from "components/VetExamOverlay/styles";
import { useVetExamContext } from "components/VetExamOverlay/VetExamProvider/VetExamProvider";
import useStyles from "./styles";

interface IProps {
  index: number;
  observationItem: IExamDetailObservation;
  detailId: string;
}

const DetailsObservation = (props: IProps) => {
  const { index, observationItem, detailId } = props;

  const classes = useStyles();
  const parentsClasses = useParentsStyles();
  const {
    values: { examDetails },
    setFieldValue
  } = useVetExamContext();
  const { lockExam } = useExamLockerContext();
  const isDisabledDeleteButton =
    index === 1 && !checkSelectingFieldsOneEntry(observationItem);

  const handleDelete = () => {
    const currentDetail = examDetails.find(
      (detail: IExamDetail) => detail.id === detailId
    );

    const updatedDetails = examDetails.map((detail: IExamDetail) => {
      if (detail.id === detailId) {
        return {
          ...detail,
          observationEntries:
            currentDetail.observationEntries.length === 1
              ? [createEmptyExamDetailObservation()]
              : detail.observationEntries.filter(
                  observation => observation.id !== observationItem.id
                )
        };
      }

      return detail;
    });

    setFieldValue(EVetExamFields.EXAM_DETAILS, updatedDetails);

    lockExam();
  };

  const renderField = (field: FormField) => {
    return (
      <VetExamFormField
        key={field.key}
        field={field}
        entryState={observationItem}
        parentEntityId={detailId}
      />
    );
  };

  return (
    <EntryItem
      entryNumber={index}
      onDeleteEntry={handleDelete}
      disabledRemoveButton={isDisabledDeleteButton}
      className={classes.observationEntry}
      title={"Observation"}
    >
      <div className={parentsClasses.fieldsWrapper}>
        {examDetailsObservationsFields.map(renderField)}
      </div>
    </EntryItem>
  );
};

export default DetailsObservation;
